import React from "react";
import { createBrowserRouter, Navigate } from "react-router";
import AuthRoutes from "components/RouteController/AuthRoutes";

const SwimmingPoolsFactory = import("pages/swimming-pools/SwimmingPoolsPage");
const SwimmingPoolsPage = React.lazy(() => SwimmingPoolsFactory);

export const useRouter = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <AuthRoutes />,
      children: [
        {
          index: true,
          element: <SwimmingPoolsPage />,
        },
        {
          path: "*",
          element: <Navigate to="/" replace />,
        },
      ],
    },
  ]);

  return router;
};
